export const TASK_UPDATE_TOOL_NAME = 'TaskUpdate'
